export default __webpack_public_path__ + "static/media/09f860e424a14cb5db2572bda261b6871581602088683.6bc33cf6.webp";